export const randomFromArray = <T>(someArray: T[]): T => {
    return someArray[Math.floor(Math.random() * someArray.length)];
};

export const randomBoolean = (chance = 0.5): boolean => {
    return Math.random() < chance;
};
